import { Icon_BackArrow, Icon_ExclamationFilled16, Sidebar } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import useNavigation from "../../../../hooks/navigation";
import useAccount from "../../../../hooks/useAccount";
import { useTeam } from "../../../../hooks/useTeams";
import { NavGroup } from "../NavGroup/NavGroup";
import { NavItem } from "../NavItem/NavItem";

import style from "./SettingsNavGroup.module.css";

export const SettingsNavGroup = () => {
  const navigation = useNavigation();
  const { teamID } = useParams();

  const { teamData, isOwner, isSeatManager, isGuest } = useTeam(teamID);

  const { data: accountData } = useAccount();

  const showBackToDashboard = !teamData?.addons?.syncForbidden && !teamData?.addons?.privateCloud;

  const canManageTeam = isOwner;
  const canManageSpaces = isSeatManager && teamData?.addons?.teamspaceManagement;
  return (
    <NavGroup>
      <Sidebar.ScrollContainer>
        {teamID && (
          <>
            {showBackToDashboard && (
              <>
                <Sidebar.Item
                  onClick={() => {
                    navigation.goToSharedWithMe({ teamID });
                  }}
                >
                  <Icon_BackArrow /> {"Back to dashboard"}
                </Sidebar.Item>
                <Sidebar.Divider />
              </>
            )}
            {!isGuest && <NavItem name="members">{"Members"}</NavItem>}
            {canManageTeam && (
              <>
                <NavItem name="subscription">
                  {"Subscription"}
                  {accountData && accountData?.subscriptionInGracePeriod && (
                    <Icon_ExclamationFilled16 className={style.subscriptionWarningIcon} />
                  )}
                </NavItem>
                {/*
                           Currently this is a shorthand instead of requesting team/:teamID/subscriptions and checking if that contains
                           an individual chargebee sub, this works since you will see this menu only if you are an owner, and if you are the owner
                           the individual sub will be also in the account response
                      */}
                {accountData?.hasChargebeeSubscription && (
                  <NavItem name="billing">{"Billing"}</NavItem>
                )}
              </>
            )}
            {(canManageSpaces || canManageTeam) && (
              <NavItem name="settings">{"Team settings"}</NavItem>
            )}
          </>
        )}
      </Sidebar.ScrollContainer>
      <Sidebar.Space marginTop={"auto"} />
      <Sidebar.Divider />
      <Sidebar.Space marginBottom={-20} />
      <Sidebar.Header>Personal</Sidebar.Header>
      <NavItem name="">{"Account settings"}</NavItem>
    </NavGroup>
  );
};
